import React from 'react';
import { PropTypes } from 'prop-types';
import classNames from 'classnames';
import HrbTranslate from "../language/HrbTranslate";
import './Cards.scss'
import ActionButton from '../button/ActionButton'
 
const CardWithTitleButton = (props) => {
    var { titleKey, buttonLabelKey, onTitleButtonClick, children, buttonClass, isDisabled } = props;
    return (
        <div className={classNames("tile is-child card hrb-card-header", { "hrb-is-disabled": Boolean(isDisabled) })}>
            <div className="card-title-with-link" >
                <h2>
                    <HrbTranslate text={titleKey} />
                </h2>
                {buttonLabelKey &&
                    <ActionButton text={buttonLabelKey} onClick={onTitleButtonClick} isDisabled={isDisabled}
                        buttonClass={buttonClass} disabled={Boolean(isDisabled)} />
                }
            </div>
            <div className="card-body">
                {children}
            </div>
        </div>
    );
}
 
CardWithTitleButton.propTypes = {
    titleKey: PropTypes.string.isRequired,
    buttonLabelKey: PropTypes.string,
    onTitleButtonClick: PropTypes.func.isRequired,
    children: PropTypes.node.isRequired,
    buttonClass: PropTypes.string,
    isDisabled: PropTypes.bool
};
 
export default CardWithTitleButton;